import { render } from "./VinculoGrupo.vue?vue&type=template&id=69563f9e"
import script from "./VinculoGrupo.vue?vue&type=script&lang=js"
export * from "./VinculoGrupo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__